export default __webpack_public_path__ + "static/media/Droneshot_Static_firstframe.37381895.png";